import React from "react";
import { InlineWidget } from "react-calendly";
import { CALENDY_URL } from "../utils/config";

const Calendy = () => {
  return (
    <div>
      <InlineWidget url={CALENDY_URL} />
    </div>
  );
};

export default Calendy;
